<template>
    <TransitionRoot as="template" :show="open">
        <Dialog class="relative z-10" @close="$emit('clodse')">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                            <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                <button type="button" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" @click="$emit('close')">
                                    <QrIcon icon="xmark" class="h-6 w-6" aria-hidden="true" />
                                </button>
                            </div>
                            <div class="sm:flex sm:items-start">
                                <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                    <QrIcon icon="triangle-exclamation" class="h-6 w-6 text-red-600" aria-hidden="true" />
                                </div>
                                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900" v-text="title"/>
                                    <div class="mt-2">
                                        <p class="text-sm text-gray-500" v-text="body"/>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <QrButton
                                    @click="$emit('confirm')"
                                    danger
                                    class="inline-flex w-full justify-center sm:ml-3 sm:w-auto"
                                    :loading="loading"
                                    :recently-failed="recentlyFailed"
                                    :recently-succeeded="recentlySucceeded"
                                    :text="buttonText"
                                />

                                <QrButton
                                    class="mt-3 inline-flex w-full justify-center sm:mt-0 sm:w-auto"
                                    @click="$emit('close')"
                                    :text="trans('button.cancel')"
                                    trans="button.cancel"
                                />
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import {trans} from "@/libs/helper.js";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import {storeToRefs} from "pinia";
import {useStatesStore} from "@/store/states.js";

const statesStore = useStatesStore();
const { loading, recentlyFailed, recentlySucceeded } = storeToRefs(statesStore);

const props = defineProps({
    open: Boolean,
    title: String,
    body: String,
    buttonText: String,
});
</script>
